module.exports = __webpack_public_path__ + "static/logo-14fe2ef2c354379656b752a8543b5842.png";